import React from "react";

/**
 * UpgradeGate — shown when a free-tier user tries to access a paid feature.
 * Displays a friendly message and a button to navigate to the pricing page.
 */
export default function UpgradeGate({
  feature,
  description,
  onUpgrade,
  isMobile,
}: {
  feature: string;
  description: string;
  onUpgrade: () => void;
  isMobile?: boolean;
}) {
  return (
    <div
      style={{
        background: "linear-gradient(135deg, #f0fdf4, #dcfce7)",
        border: "2px solid #86efac",
        borderRadius: 20,
        padding: isMobile ? 24 : 40,
        textAlign: "center",
        maxWidth: 480,
        margin: "40px auto",
      }}
    >
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: 20,
          background: "linear-gradient(135deg, #4ade80, #2d5a27)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto 20px",
        }}
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      </div>
      <h2
        style={{
          fontSize: isMobile ? 20 : 24,
          fontWeight: 700,
          fontFamily: "'DM Serif Display', serif",
          margin: "0 0 8px",
          color: "#1a1f16",
        }}
      >
        Unlock {feature}
      </h2>
      <p
        style={{
          fontSize: 14,
          color: "#4b7a40",
          margin: "0 0 24px",
          lineHeight: 1.6,
        }}
      >
        {description}
      </p>
      <button
        onClick={onUpgrade}
        style={{
          background: "#2d5a27",
          color: "#fff",
          border: "none",
          borderRadius: 12,
          padding: "14px 32px",
          fontSize: 15,
          fontWeight: 700,
          cursor: "pointer",
          fontFamily: "inherit",
          transition: "transform 0.15s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
      >
        View Plans & Upgrade
      </button>
      <p
        style={{
          fontSize: 12,
          color: "#6b7280",
          marginTop: 12,
        }}
      >
        Starting at $7.99/month. Cancel anytime.
      </p>
    </div>
  );
}
